class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = 0;
    this.touchStartY = 0;
    this.touchEndY = 0;
    this.announcementBar = this.querySelector(
      "#wt-announcement__container"
    );
    this.announcementInterval = null;

    this.changeAnnouncement = this.changeAnnouncement.bind(this);
    this.previousAnnouncement = this.previousAnnouncement.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.hideForOneDay = this.hideForOneDay.bind(this);
    this.restartInterval = this.restartInterval.bind(this);
    this.isMobileView = this.isMobileView.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    if (
      !this.announcementBar?.classList.contains(
        "wt-announcement__container--marquee"
      )
    ) {
      this.announcementInterval = setInterval(
        this.changeAnnouncement,
        5000
      );

      if (this.announcementBar) {
        this.announcementBar.addEventListener(
          "touchstart",
          this.handleTouchStart,
          { passive: true }
        );
        this.announcementBar.addEventListener(
          "touchmove",
          this.handleTouchMove,
          { passive: true }
        );
        this.announcementBar.addEventListener(
          "touchend",
          this.handleTouchEnd,
          { passive: true }
        );

        this.announcementBar.addEventListener(
          "touchstart",
          () => clearInterval(this.announcementInterval),
          { passive: true }
        );

        this.announcementBar.addEventListener(
          "touchend",
          this.restartInterval,
          { passive: true }
        );
      }
    }

    if (this.announcementBar) {
      this.announcementBar.style.transition =
        "transform 0.5s ease-in-out";
    }

    this.closeButton = this.querySelector(
      ".wt-announcement__close"
    );
    if (this.closeButton) {
      this.closeButton.addEventListener(
        "click",
        this.hideForOneDay
      );
    }

    window.addEventListener("resize", this.handleResize);
  }

  /* ---------- Resize ---------- */

  handleResize() {
    if (window.innerWidth >= 900) {
      if (this.announcementBar) {
        this.announcementBar.style.transform =
          "translateY(0)";
        this.currentIndex = 0;
      }
    }
  }

  isMobileView() {
    return window.innerWidth < 900;
  }

  restartInterval() {
    clearInterval(this.announcementInterval);
    this.announcementInterval = setInterval(
      this.changeAnnouncement,
      5000
    );
  }

  /* ---------- Hide ---------- */

  hideForOneDay() {
    const oneDayLater =
      new Date().getTime() + 24 * 60 * 60 * 1000;
    localStorage.setItem(
      "wt-announcement-hidden",
      oneDayLater
    );
    this.style.display = "none";
  }

  /* ---------- Next Slide (UP) ---------- */

  changeAnnouncement() {
    if (!this.isMobileView()) return;

    const totalSlides =
      this.announcementBar?.children.length || 0;

    this.currentIndex =
      (this.currentIndex + 1) % totalSlides;

    const newPosition = -(this.currentIndex * 100);

    if (this.announcementBar) {
      this.announcementBar.style.transform =
        `translateY(${newPosition}%)`;
    }

    /* Loop Reset */
    if (this.currentIndex === 0 && this.announcementBar) {
      setTimeout(() => {
        this.announcementBar.style.transition = "none";
        this.announcementBar.style.transform =
          "translateY(0)";
        this.currentIndex = 0;

        setTimeout(() => {
          this.announcementBar.style.transition =
            "transform 0.5s ease-in-out";
        }, 0);
      }, 490);
    }
  }

  /* ---------- Previous Slide (DOWN) ---------- */

  previousAnnouncement() {
    if (!this.isMobileView()) return;

    const totalSlides =
      this.announcementBar?.children.length || 0;

    this.currentIndex =
      (this.currentIndex - 1 + totalSlides) %
      totalSlides;

    const newPosition = -(this.currentIndex * 100);

    if (this.announcementBar) {
      this.announcementBar.style.transform =
        `translateY(${newPosition}%)`;
    }
  }

  /* ---------- Touch Events (Vertical Swipe) ---------- */

  handleTouchStart(e) {
    if (this.isMobileView()) {
      this.touchStartY = e.touches[0].clientY;
    }
  }

  handleTouchMove(e) {
    if (this.isMobileView()) {
      this.touchEndY = e.touches[0].clientY;
    }
  }

  handleTouchEnd() {
    const swipeThreshold = 30;

    if (
      Math.abs(this.touchEndY - this.touchStartY) >
      swipeThreshold
    ) {
      if (this.touchEndY < this.touchStartY) {
        this.changeAnnouncement(); // swipe up
      } else {
        this.previousAnnouncement(); // swipe down
      }
    }
  }

  /* ---------- Cleanup ---------- */

  disconnectedCallback() {
    clearInterval(this.announcementInterval);

    if (this.announcementBar) {
      this.announcementBar.removeEventListener(
        "touchstart",
        this.handleTouchStart
      );
      this.announcementBar.removeEventListener(
        "touchmove",
        this.handleTouchMove
      );
      this.announcementBar.removeEventListener(
        "touchend",
        this.handleTouchEnd
      );
    }

    window.removeEventListener(
      "resize",
      this.handleResize
    );
  }
}

customElements.define(
  "announcement-bar",
  AnnouncementBar
);
